import { ZALO_APP_ID } from 'src/constants';
import { BASE_URL } from 'src/constants/env';

const getCodeVerify = async () => {
    const { generate } = await import('randomstring');
    return generate(256);
};

const getCodeChallenge = async (verify: string) => {
    const { createHash } = await import('crypto');
    const base64Digest = createHash('sha256').update(verify).digest('base64');
    return base64Digest
        .replace(/\+/g, '-')
        .replace(/\//g, '_')
        .replace(/=+$/, '');
};

export const login = async (_cb?: any) => {
    (window as any).fnCallbackLogin = _cb;
    const codeVerify = await getCodeVerify();
    const codeChallenge = await getCodeChallenge(codeVerify);
    let redirectUrl = encodeURIComponent(`${BASE_URL}`);

    const url = `https://oauth.zaloapp.com/v4/permission?app_id=${ZALO_APP_ID}&redirect_uri=${redirectUrl}&code_challenge=${codeChallenge}&state=${codeVerify}`;
    const height = 820;
    const width = 1020;

    let top = window.screen.height - height;
    top = top > 0 ? top / 2 : 0;
    let left = window.screen.width - width;
    left = left > 0 ? left / 2 : 0;

    let win = window.open(
        url,
        '_blank',
        `location=yes,height=${height},width=${width},top=${top},left=${left},scrollbars=yes,status=yes`,
    );

    if (!win) {
        (window as any).location.replace(url);
    }
};
